<script>
  import AddTask from "./todo/AddTask.svelte";
  import Todos from "./todo/Todos.svelte";

  export let toggleAdd = false;
</script>

<style>
  .todo-card {
    display: grid;
    justify-content: center;
    justify-items: center;
    align-items: center;
    grid-gap: 1em;
  }

  h1 {
    filter: drop-shadow(-5px 5px 5px rgba(0, 0, 0, 0.5));
  }

  .add {
    justify-self: flex-end;
    cursor: pointer;
  }

  img {
    width: 45px;
    height: 45px;
    transition: all 0.2s ease-in;
    border: 3px solid rgb(73, 77, 78, 0.7);
    border-radius: 50%;
  }

  img:hover {
    filter: invert(0.85) sepia(1) hue-rotate(150deg) saturate(1.5) brightness(1);
    border: 3px solid rgb(0, 0, 0, 0.7);
    border-radius: 50%;
  }

  .back {
    display: flex;
    align-items: center;
    margin-right: 2em;
  }
</style>

<div class="todo-card">

  {#if toggleAdd}
    <h1>New Task</h1>
    <AddTask on:toggleAdd={() => (toggleAdd = !toggleAdd)} />
  {:else}
    <h1>Todo List</h1>
    <Todos />
  {/if}

  <div class="add">
    {#if !toggleAdd}
      <img
        on:click={() => (toggleAdd = !toggleAdd)}
        src="./images/circle-add.svg"
        alt="add todo" />
    {:else}
      <div class="back">
        <h3>Back &nbsp;</h3>
        <img
          on:click={() => (toggleAdd = !toggleAdd)}
          src="./images/back.svg"
          alt="back to todos" />
      </div>
    {/if}

  </div>
</div>
